import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';
import { ContactRelayDialog } from './ContactRelayDialog';

interface ContactRelayButtonProps {
  relayId: string;
  relayName: string;
}

export const ContactRelayButton = ({ relayId, relayName }: ContactRelayButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        <MessageSquare className="h-4 w-4 mr-2" />
        Contacter le point relais
      </Button>
      <ContactRelayDialog
        open={open}
        onOpenChange={setOpen}
        relayId={relayId}
        relayName={relayName}
      />
    </>
  );
};
